import React, { useEffect, useState } from 'react'
import { Descriptions, Modal} from 'antd';
import { useBnsGongNengUpdateQuery } from '../../store/BnsKeJiApi';
function ModuleCheck(props) {
    const [open,setOpen] = useState(false)    
    const [info,setInfo] = useState({
            ebn_team_num:'',
        })
        const {data,isSuccess} = useBnsGongNengUpdateQuery({bgn_id:props.bgn_id},{skip:!open})
        useEffect(() => {
            if(isSuccess){
                if(data.Status==='success'){
                    setInfo({
                        bgn_name:data.Result.bgn_name,                  
                        bgn_dept_id:data.Result.bgn_dept_id,                  
                        bgn_content:data.Result.bgn_content,                  
                        bgn_dept_name:data.Result.bgn_dept_name,                                        
                        bgn_cname:data.Result.bgn_cname,                                        
                        bgn_ctime:data.Result.bgn_ctime,                                        
                        bgn_bg_name:data.Result.bgn_bg_name,                                        
                    })
                    // console.log(array);
                }
            }
        },[data, isSuccess])
        const items = [  
            {
                key:'bgn_content',
                label:'项目名称',
                children:info.bgn_bg_name,
                contentStyle:{fontSize:"14px"},
                span:3
            },      
            {
                key:'bgn_name',
                label:'模块名称',
                children:info.bgn_name,
                contentStyle:{fontSize:"14px"},
                span:3
            },        
            {
                key:'bgn_content',
                label:'模块说明',
                children:info.bgn_content,
                contentStyle:{fontSize:"14px"},
                span:3
            },        
                  
            {
                key:'bgn_dept_name',
                label:'模块部门',
                children:<>{info.bgn_dept_name}</>,
                contentStyle:{fontSize:"14px"},
                span:3
            },
            {
                key:'bgn_ctime',
                label:'新增时间',
                children:[info.bgn_ctime, info.bgn_cname].filter(Boolean).join(' '),
                ccontentStyle:{fontSize:"14px"},
                span:3
            },
            
        ]
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.bgn_name}</a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
                title='查看模块'
            >            
                <Descriptions
                    items={items}
                    bordered
                />          
            </Modal>
        </>
    )
}

export default ModuleCheck